<!--
 * @Author: cryi.liu
 * @Date: 2020-06-17 10:46:03
 * @LastEditTime: 2020-06-18 15:38:30
 * @Description: 题目信息
-->
<template>
  <div class="question-info">
    <table>
      <tbody>
        <tr>
          <td class="category">考试名称：
            <span>{{ examName }}</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td class="category">题目：
            <span>{{ content }}</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td class="category">分值：
            <span>{{ score }}分</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td class="category" style="width: 100%">参考答案：
            <span>{{ tip }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'QuestionInfo',
  props: {
    questionIndex: { type: Number, required: true },
  },
  computed: {
    ...mapGetters({
      questionList: 'answerMarkStore/questionList',
    }),
    examName() {
      return this.questionList[this.questionIndex].examName;
    },
    content() {
      return this.questionList[this.questionIndex].content;
    },
    score() {
      return this.questionList[this.questionIndex].totalScore;
    },
    tip() {
      return this.questionList[this.questionIndex].tip ? this.questionList[this.questionIndex].tip : '';
    },
  },
};
</script>

<style lang="less" scoped>
.question-info {
  width: 100%;

  > table {
    flex: 0 0 100%;
    width: 100%;

    > tbody {
      width: 100%;

      > tr {
        width: 100%;
        height: 32px;

        > td {
          width: 50%;
          vertical-align: middle;
          font-size: 12px;
          border-bottom: 1px solid #ddd;

          &.category {
            font-weight: bold;

            > span {
              font-weight: normal;
            }

            > a {
              margin-right: 16px;

              &:last-of-type {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
